import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketProfileItemFacade } from './automotive-aftermarket-profile-item.facade';
import { map, switchMap, take } from 'rxjs/operators';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../../catalog-search-criteria';
import { AutomotiveAftermarketSearchCriteria } from '../../automotive-aftermarket';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileItemGuard  {
  constructor(
    private automotiveAftermarketProfileItemFacade: AutomotiveAftermarketProfileItemFacade,
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
  ) {}

  canActivate(): Observable<boolean> {
    return this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.AutomotiveAftermarket)
      .pipe(
        map(({ id }: AutomotiveAftermarketSearchCriteria) => id),
        take(1),
        switchMap((id: number) => (id ? loadStoreState(this.automotiveAftermarketProfileItemFacade, id) : of(true))),
      );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketProfileItemFacade);
  }
}
